import { adminApi } from "@/api/adminClient";

export const fetchContactMessages = async (status = null) => {
  const params = status ? { status } : {};
  const res = await adminApi.get("/admin/contact-messages", { params });
  return res.data;
};

export const updateContactMessageStatus = async (id, status) => {
  const res = await adminApi.patch(`/admin/contact-messages/${id}`, { status });
  return res.data;
};

export const deleteContactMessage = async (id) => {
  const res = await adminApi.delete(`/admin/contact-messages/${id}`);
  return res.data;
};

export const CONTACT_STATUS_META = {
  new: { label: "Nieuw", color: "#F3C300", textColor: "#173A5E" },
  read: { label: "Gelezen", color: "#22a56b", textColor: "#FFFFFF" },
  archived: { label: "Gearchiveerd", color: "#5A7594", textColor: "#FFFFFF" },
};
